import { render, staticRenderFns } from "./clone.vue?vue&type=template&id=63e1c6e0&scoped=true"
import script from "./clone.vue?vue&type=script&lang=js"
export * from "./clone.vue?vue&type=script&lang=js"
import style0 from "./clone.vue?vue&type=style&index=0&id=63e1c6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1c6e0",
  null
  
)

export default component.exports